import { formatDuration } from '@socialive/common';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

const FILL = {
  s: '00',
  'm:ss': '00:00',
  'h:mm:ss': '00:00:00',
};

const Countdown = ({ format, seconds: initSeconds, onComplete, className }) => {
  const [seconds, setSeconds] = useState(initSeconds);
  const fill = useMemo(() => FILL[format], [format]);

  useEffect(() => {
    if (!seconds) onComplete?.();
  }, [seconds, onComplete]);

  useEffect(() => {
    const tick = () => setSeconds((cur) => Math.max(0, cur - 1));
    const timerId = setInterval(tick, 1_000);
    return () => clearInterval(timerId);
  }, []);

  return (
    <span className={className}>
      {formatDuration(seconds * 1000)
        .replace(/^(00:)*0?:?/, '')
        .padStart(fill.length, fill)
        .replace(/^0(\d)/, '$1')}
    </span>
  );
};

Countdown.propTypes = {
  format: PropTypes.oneOf(Object.keys(FILL)),
  seconds: PropTypes.number,
  onComplete: PropTypes.func,
  className: PropTypes.string,
};

Countdown.defaultProps = {
  format: 's',
  seconds: 0,
  onComplete: undefined,
  className: undefined,
};

export default Countdown;
